import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import assets from "./assets";
import asset from "./asset";
import auth from "./auth";
import content from "./content";
import runningOrder from "./runningOrder";
import app from "./app";
import axisOrder from "./axisOrder";
import axisOrders from "./axisOrders";
import info from "./info";
import luciPanel from "./luciPanel";
import axisDeficientAssetUrl from "./axisDeficientAssetUrl";
import clipperMovie from "./clipperMovie";
import keyShortcuts from "./keyShortcuts";
import publish from "./publish";
import snackbar from "./snackbar";
import savedItems from "./savedItems";
import userInterface from "./userInterface";
import savedState from "./savedState";

export default combineReducers({
  routing: routerReducer,
  assets,
  asset,
  auth,
  content,
  runningOrder,
  app,
  axisOrder,
  axisOrders,
  info,
  luciPanel,
  axisDeficientAssetUrl,
  clipperMovie,
  keyShortcuts,
  publish,
  snackbar,
  savedItems,
  userInterface,
  savedState
});



// WEBPACK FOOTER //
// ./app/reducers/index.js